module.exports = __webpack_public_path__ + "img/1_025.a2527cef.jpg";